import { QUERIES } from '@repo/ui/queries';
import { themeStyle as uiKitThemeStyle } from '@repo/ui-kit/themeStyle';
import styled from 'styled-components';

export const SUBMENU_GAP = 2;
export const SUBMENU_TOP_BOTTOM_PADDING = 4;
export const SUBMENU_PADDING_OPENED = `${SUBMENU_TOP_BOTTOM_PADDING}px 0px ${SUBMENU_TOP_BOTTOM_PADDING}px 24px`;
export const SUBMENU_PADDING_CLOSED = '0px 0px 0px 24px';

export const NavigationMenuListItem = styled.li`
  list-style: none;
`;

export const ChevronWrapper = styled.div<{ $isExpanded?: boolean }>`
  margin-left: auto;
  rotate: ${({ $isExpanded }) => ($isExpanded ? '90deg' : '0deg')};

  &.can-animate {
    ${QUERIES.largeTabletAndUp} {
      transition: rotate ${uiKitThemeStyle.motionDuration300} ease-in-out;
    }
  }
`;

export const NavigationSubMenuList = styled.ul<{ 'aria-expanded': boolean }>`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${SUBMENU_GAP}px;

  max-height: ${({ 'aria-expanded': expanded }) => (expanded ? 'auto' : '0')};
  overflow: hidden;
  padding: ${({ 'aria-expanded': expanded }) =>
    expanded ? SUBMENU_PADDING_OPENED : SUBMENU_PADDING_CLOSED};
  margin-top: ${({ 'aria-expanded': expanded }) =>
    expanded ? 'var(--spacing-2)' : '0'};

  /* Add padding to create space for the focus outline */
  padding-right: var(--spacing-4);
  margin-right: calc(-1 * var(--spacing-4));

  &.can-animate {
    ${QUERIES.largeTabletAndUp} {
      transition:
        max-height ${uiKitThemeStyle.motionDuration300} ease-in-out,
        padding ${uiKitThemeStyle.motionDuration300} ease-in-out,
        margin-top ${uiKitThemeStyle.motionDuration300} ease-in-out;
    }
  }
`;
